import { useState, useContext } from 'react';
import UploadFileStyles from './UploadFileForm.module';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from '@mui/material/Button';
import useAxios from '../../hooks/useAxios';
import AuthContext from '../../contexts/auth-context';
import AppContext from '../../contexts/app-context';
import { urls, toastify_status, pricesFileIndicators, app_paths } from '../config/variables';
import { useDropzone } from 'react-dropzone';
import Toastify from '../ui/Toastify';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next'
import * as motion from "motion/react-client"
import Tooltip from '@mui/material/Tooltip';
import samplePriceData from './samplePricesData';
import { FaPills } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

const UploadFileForm2 = () => {
  const classes = UploadFileStyles()
  const navigate = useNavigate();
  // const [selectedFacility, setSelectedFacility] = useState('');
  const [selectedFile, setSelectedFile] = useState('');
  const [fileIndicator, setFileIndicator] = useState('');
  const [selectedTab, setSelectedTab] = useState('')
  const [uploadedFileResponse, setUploadedFileResponse] = useState('')
  const [uploadedFileError, setUploadedFileError] = useState('')
  const { operation } = useAxios();
  const authCtx = useContext(AuthContext);
  const appCtx = useContext(AppContext);
  const userRole = appCtx.userRole;
  const { t } = useTranslation('setting')
  const indicators = pricesFileIndicators()

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      if (acceptedFiles[0].name.split('.').pop() === 'csv') {
        setSelectedFile(acceptedFiles[0]);
        // setSelectedFacility('')
        setUploadedFileResponse('')
        setUploadedFileError('')

      } else {
        Toastify({
          message: 'Select CSV File',
          state: toastify_status.WARNING
        });
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  // const handleChangeFacility = (e) => {
  //   const { value } = e.target;
  //   setSelectedFacility(value);
  //   setUploadedFileResponse('')
  //   setUploadedFileError('')
  // };

  const handleChangeTab = (tab) => {
    setSelectedTab(tab)
    setFileIndicator(tab.value);
    setSelectedFile('')
    // setSelectedFacility('')
    setUploadedFileResponse('')
    setUploadedFileError('')
  }

  // formData.append('pharmacy_drug_file', selectedFile);
  const handleUploadFile = () => {
    const formData = new FormData();
    formData.append(fileIndicator, selectedFile);
    // formData.append('facility', selectedFacility);
    const url = fileIndicator === 'icd_file'
    ? urls.FACILITY_ICD_PRICES
    : fileIndicator === 'cpt_file'
    ? urls.FACILITY_CPT_PRICES
    : fileIndicator === 'drug_file'
    ? urls.FACILITY_DRUG_PRICES
    : fileIndicator === 'pharmacy_drug_file'
    ? urls.PHARMACY_DRUG_PRICES
    : '';

    operation(
      {
        method: 'POST',
        url,
        headers: { Authorization: `token ${authCtx.token}` },
        data: formData,
      },
      handleSuccessFullyUploadedFile,
      handleErrorUploadedFile
    );
  };

  const handleSuccessFullyUploadedFile = (response) => {
    Toastify({
      message: response,
      state: toastify_status.SUCCESS
    });
    // setSelectedFacility('');
    setUploadedFileError('')
    setUploadedFileResponse(response)
    if (userRole === 'pharmacy_admin') {
      navigate(app_paths.INVENTORY_PAGE, { replace: true });
    }
  };

  const handleErrorUploadedFile = (error) => {
    setUploadedFileError(error)
    Toastify({
      message: error?.response?.data,
      state: toastify_status.ERROR
    });
  };

  const downloadSampleFile = () => {
      const fileType = 
      fileIndicator === 'icd_file' ? 'icd' :
      fileIndicator === 'cpt_file' ? 'cpt' :
      fileIndicator === 'drug_file' ? 'drug' :
      fileIndicator === 'pharmacy_drug_file' ? 'pharmacy_drug' :
      '';
      const url = userRole === 'pharmacy_admin'
      ? urls.DOWNLOAD_SAMPLE_PHARMACY_DRUGS_FILE // ---> this is for pharmacy drug file download.
      : urls.DOWNLOAD_SAMPLE_PRICES_FILE.replace(':fileType', fileType) // ---> this is for facility icd, cpt, drug file download.
        operation(
      {
        method: 'GET',
        url: url,
        headers: { Authorization: `token ${authCtx.token}` },
        responseType: 'blob',
      },
      (fileResponse) => {
        const blob = new Blob([fileResponse], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileType} price.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
      },
      handleErrorDownloadedPricsFile,
    );
  };

  const handleErrorDownloadedPricsFile = (error) => {
    Toastify({
      message: error?.response?.data || 'An error occurred when downloading sample prices',
      state: toastify_status.ERROR
    });
  }
  
  const uploadFileComponent = (selectedTab) => {
    return <motion.div key={selectedTab ? selectedTab.value : "empty"}
    initial={classes.upload_file_animation.initial}
    animate={classes.upload_file_animation.animate}
    transition={classes.upload_file_animation.transition}>
    <Typography sx={classes.upload_file_title}>Upload {selectedTab.label}</Typography>
    <Box
        sx={[classes.drop_zone, isDragActive && classes.drop_zone_active]}
        {...getRootProps()}
      >
        <input {...getInputProps()} accept=".csv" />
        <Box>
          {isDragActive ? (
            <Typography sx={classes.drag_here_text}>
              {t('Prices.DropHere')}
            </Typography>
          ) : (
            <Box>
              <Typography
                sx={{
                  ...classes.selected_file_name,
                  ...(uploadedFileError ? classes.cloud_icon_rejected : {}),
                }}
              >
                {selectedFile.name}
              </Typography>

              {uploadedFileResponse && (
                <motion.span
                  initial={classes.sample_data_animation.initial}
                  animate={classes.sample_data_animation.animate}
                  transition={classes.sample_data_animation.transition}
                >
                  <Typography sx={[classes.uploading_file_message, classes.cloud_icon_active]}>
                     Uploaded successfully
                  </Typography>
                </motion.span>
              )}

              {uploadedFileError && (
                <motion.span
                  initial={classes.sample_data_animation.initial}
                  animate={classes.sample_data_animation.animate}
                  transition={classes.sample_data_animation.transition}
                >
                  <Typography sx={[classes.uploading_file_message, classes.cloud_icon_rejected]}>
                    Failed to upload
                  </Typography>
                </motion.span>
              )}

              <CloudUploadIcon
                sx={{
                  ...classes.cloud_icon,
                  ...(selectedFile && !uploadedFileError ? classes.cloud_icon_active : {}),
                  ...(selectedFile && uploadedFileError ? classes.cloud_icon_rejected : {}),
                }}
              />

              <Typography sx={classes.drag_text}>
                {t('Prices.DragAndDrop')}
              </Typography>
            <Typography sx={classes.drag_text}>
              -{t('Prices.Or')}-
            </Typography>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
            >
              {t('Prices.BrowseFiles')}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
    <Box sx={classes.submit_box}>
      {/* <Box sx={classes.facility_box}>
        <InputLabel
          sx={selectedFile ? classes.input_label : {}}
          id="select-facility"
        >
          {t('Prices.SelectFacility')}
        </InputLabel>
        <Select
          labelId="select-facility"
          sx={classes.facility_info_select}
          value={selectedFacility}
          disabled={!selectedFile}
          onChange={handleChangeFacility}
        >
          {typeof facilities !== 'undefined' &&
            facilities.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </Box> */}
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        onClick={handleUploadFile}
        disabled={!selectedFile}
        sx={classes.submit_button}
      >
        Submit {selectedTab.label}
      </Button>
    </Box>
  </motion.div>
  }

  const fileIndicatorIcon = (indicator) => {
    switch (indicator) {
      case 'icd_file':
        return <LocalHospitalIcon sx={classes.indicator_icon} />;
      case 'cpt_file':
        return <MedicalInformationIcon sx={classes.indicator_icon} />;
      case 'drug_file':
        return <MedicalServicesIcon sx={classes.indicator_icon} />;
      case 'pharmacy_drug_file':
        return <FaPills size={24}  sx={classes.indicator_icon} />;
      default:
        return null;
    }
  };

  return (
    <Box sx={classes.container}>
      <Box sx={classes.container_title_box}>
          <InsertDriveFileIcon sx={classes.container_title_icon}/>
          <Typography sx={classes.container_title_text}>
            Upload Prices
          </Typography>
        </Box>
        {/* Sidebar */}
        <Box sx={classes.content}>
        <Box sx={classes.sidebar}>
            <Typography sx={classes.sidebar_title}>
              Select File Indicator
            </Typography>
            
          <Box sx={classes.sidebar_tabs_container}>
            {indicators
              .filter(tab => tab.role.includes(userRole))
              .map(tab => (
                <Box
                  key={tab.value}
                  sx={[
                    classes.sidebar_tab,
                    selectedTab.value === tab.value && classes.sidebar_tab_active
                  ]}
                  onClick={() => handleChangeTab(tab)}
                >
                  <Box
                    sx={[
                      classes.sidebar_tab_content,
                      selectedTab.value === tab.value && classes.sidebar_tab_content_active
                    ]}
                  >
                    {fileIndicatorIcon(tab.value)}
                    <Typography sx={classes.sidebar_tab_content_text}>
                      {tab.title}
                    </Typography>
                  </Box>
                </Box>
              ))
            }
          </Box>
          </Box>
          {/* Upload Area */}
          <Box sx={classes.upload_area}>
            {['icd_file', 'cpt_file', 'drug_file', 'pharmacy_drug_file'].includes(selectedTab.value)
              ? uploadFileComponent(selectedTab)
              : <Box sx={classes.upload_area_empty}>
                  <KeyboardBackspaceIcon sx={classes.upload_area_empty_icon} />
                  <Typography sx={classes.upload_area_empty_primary_text}>
                    Select file type to upload
                  </Typography>
                  <Typography sx={classes.upload_area_empty_secondary_text}>
                    Choose a file type from the left menu to begin the upload process.
                  </Typography>
                </Box>}
          </Box>
          {/* Sample Data */}
          <Box sx={classes.sample_data}>
            {selectedTab ? (
              <motion.div
                key={selectedTab ? selectedTab.value : 'empty'}
                initial={classes.sample_data_animation.initial}
                animate={classes.sample_data_animation.animate}
                transition={classes.sample_data_animation.transition}
              >
                <Box sx={classes.sample_data_title_box}>
                  <Tooltip
                    title={
                      <Typography sx={classes.sample_data_title_tooltip}>
                        You can upload a CSV file in the same format as the one shown in
                        the table below. You can also download a copy of the boilerplate file.
                      </Typography>
                    }
                  >
                    <InfoIcon sx={classes.sample_data_tooltip_icon} />
                  </Tooltip>
                  <Typography sx={classes.sample_data_title_text}>
                    Sample Data
                  </Typography>
                </Box>

              <Box sx={classes.sample_data_table_box}>
                <Box sx={classes.sample_data_table_heading}>
                  <Box sx={[classes.table_dotes, classes.red_dot]} />
                  <Box sx={[classes.table_dotes, classes.orange_dot]} />
                  <Box sx={[classes.table_dotes, classes.green_dot]} />
                </Box>
                <Box sx={classes.sample_data_table_content}>
                  {samplePriceData[selectedTab.value].map((row, index) => {
                    return <Box key={index} sx={classes.sample_data_table_field}>
                      {row.map((item, index) => {
                        return <Box key={index} sx={classes.sample_data_table_value}>
                          <Typography sx={classes.sample_data_table_value_text}>{item}</Typography>
                        </Box>
                      })}
                    </Box>
                  })}
                </Box>
              </Box>
                  <motion.div
                  initial={classes.sample_data_table_footer_animation.initial}
                  animate={classes.sample_data_table_footer_animation.animate}
                  transition={classes.sample_data_table_footer_animation.transition}
                  style={classes.sample_data_table_footer}
                  >
                    <Button
                      variant="contained"
                      startIcon={<FileDownloadIcon />}
                      sx={classes.download_sample_data_button}
                      onClick={downloadSampleFile}

                    >
                      Download
                    </Button>
                  </motion.div>
              </motion.div>
            ) : (
              <Box sx={classes.sample_data_empty_box}>
                <InfoIcon sx={classes.sample_data_empty_icon} />
                <Typography sx={classes.sample_data_epty_primary_text}>
                  Sample data will appear here
                </Typography>
                <Typography sx={classes.sample_data_epty_secondary_text}>
                  Select a file type to see the corresponding sample data and template.
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
    </Box>
  );
};
export default UploadFileForm2;
